export enum ApplicationStatuses {
  transactionFlowStarted = 'transactionFlowStarted',
  transactionFlowCompleted = 'transactionFlowCompleted',
  submissionStarted = 'submissionStarted',
  submissionCompleted = 'submissionCompleted',
}
